module.exports = __webpack_public_path__ + "static/media/HEADER3.62976a30.png";